import type Api from 'common/lib/api';

const getVersionApi = (api: Api) => ({
  getVersion: () => api.get('/version/'),
});

export default getVersionApi;
